import { ArticleLocation, IListData, ILocation } from '../interfaces/read';

export function singleReadLinkByUnderscoreArticleId(articleId: string, meta?: string, host?: string) {
    if (!articleId || !articleId.trim()) {
        throw new Error('Missing required fields');
    }
    return singleReadLink(articleId.replace('_', '/'), meta, host);
}

export function singleReadLinkByPublisherArticleId(publisherId: string, articleId: string, meta?: string, host?: string) {
    if (!articleId || !articleId.trim() || !publisherId || !publisherId.trim()) {
        throw new Error('Missing required fields');
    }
    return singleReadLink(`${publisherId}/${articleId}`, meta, host);
}

// The sentence a read link's last segment names: a sentence key in its short form, language, section, paragraph and
// sentence ("en-b-015-001", as getLang builds it with ARTICLE_KEY_LANG_DELIMITER), or followed by a word's index
// ("en-b-015-001-4487"). Null for anything else.
export function readSentenceLocation(meta: string): ILocation | null {
    const key = /^[a-z]{2,3}-([tbg])-(\d{3})-(\d{3})(?:-\d+)?$/.exec(meta ?? '');
    if (!key) {
        return null;
    }
    const location = key[1] === 't' ? ArticleLocation.Title : key[1] === 'g' ? ArticleLocation.Grid : ArticleLocation.Body;
    return { location, index: Number(key[2]), sentence: Number(key[3]) };
}

export function singleReadLink(id: string, meta?: string, host?: string) {
    if (!id || !id.trim()) {
        throw new Error('Missing required fields');
    }
    host = host && host.trim() ? host : '';
    meta = meta && meta.trim() ? `/${meta}` : '';
    return `${host}/read/${id}${meta}`;
}

// Build an Athena/Trino `concat(...) as <alias>` expression that yields an absolute read-article URL.
// `baseUrl` is the instance's external host origin (e.g. https://app.example.com or the dev static host);
// this stays deployment-agnostic rather than assuming a causalitylink.com subdomain.
export function singleReadLinkBySql(value: string, as: string, baseUrl: string) {
    if (!value || !value.trim() || !baseUrl || !baseUrl.trim() || !as || !as.trim()) {
        throw new Error('Missing required fields');
    }
    const base = baseUrl.trim().replace(/\/+$/, '');
    return `concat('${base}/read/', ${value}) as ${as}`;
}

export function listReadLink(quotes: IListData []) {
    if (!quotes || !quotes.length) {
        throw new Error('Missing required fields');
    }
    const links = quotes.map((m) => {
        if (m.field && m.paragraph) {
            return `${m.publisher}_${m.article},${m.field}${m.paragraph}`;
        }
        return `${m.publisher}_${m.article}`;
    }).join('/');
    return `/read/list/${links}`;
}
